import { render, staticRenderFns } from "./InputFile1.vue?vue&type=template&id=3d8eb5ad&scoped=true"
import script from "./InputFile1.vue?vue&type=script&lang=js"
export * from "./InputFile1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8eb5ad",
  null
  
)

export default component.exports